export default (Temp: number): number =>
  Math.exp(
    (-349 / 298.15 +
      2780 * (1 / 298.15 - 1 / (Temp + 273.15)) +
      76 * (298.15 / (Temp + 273.15) - 1 + Math.log((Temp + 273.15) / 298.15))) /
      8.314
  );
